import { render, staticRenderFns } from "./GoodsIndex.vue?vue&type=template&id=4b7d753e&scoped=true&"
import script from "./GoodsIndex.vue?vue&type=script&lang=js&"
export * from "./GoodsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d753e",
  null
  
)

export default component.exports